import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Navigation from "./navigation";

let vh = window.innerHeight * 0.01;

const useStyles = makeStyles({
    scrollable: {
        ['@media (max-width: 640px)']: {
            overflowY: 'scroll',
            minHeight: 100*vh-68,
        },
        ['@media (min-width: 640px)']: {
            overflowY: 'scroll',
            minHeight: 720-68,
        },
    },
    main: {
        position: 'relative',
        background: 'linear-gradient(180.02deg, #FF8A00 0.02%, #58AF56 121.49%, #58AF56 134.83%)',
        minHeight: 'inherit',
        height: '100%',
        width: '100%',
        padding: 0,
        margin: 0,
        top: 0,
        left: 0,
        boxSizing: 'inherit',
        borderRadius: 'inherit',
        display: 'flex',
        flexFlow: 'column',
    },
    image: {
        align: 'left',
        margin: '12px',
        marginRight: '24px',
        marginLeft: '24px',
        height: '48px',
        width: '60px',
    },
    textHeader: {
        margin: 0,
        paddingTop: '30px',
        marginBottom: '20px',
        fontStyle: 'normal',
        fontSize: '22px',
        fontWeight: 'bold',
        lineHeight: '30px',
        textAlign: 'center',
        color: '#000000',
        flex: '0 1 auto',
    },
    instructionRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '0 1 auto',
    },
    textInstruction: {
        fontStyle: 'normal',
        ['@media (max-width: 400px)']: {
          fontSize: '16px',
          lineHeight: '24px',
        },
        fontSize: '18px',
        lineHeight: '24px',
        textAlign: 'left',
        color: '#000000',
        width: '60%',
        marginRight: '24px',
    },
    divider: {
        align: 'center',
        background: '#000000',
        border: "3px solid #000000",
        boxSizing: "border-box",
        borderRadius: '3px',
        marginLeft: '30%',
        marginRight: '30%',
        marginBottom: '50px',
        width: '40%',
        flex: '0 1 auto',
    },
    lastElement: {
        paddingBottom: '15%',
    },
});

export default function Instructions() {
    const classes = useStyles();
    return (
        <main className={classes.main}>
            <div className={classes.scrollable}>
                <h2 className={classes.textHeader}>Krótka instrukcja</h2>
                <div className={classes.divider}/>
                <div className={classes.instructionRow}>
                    <img src={'noun-swipe-200022 1.svg'} className={classes.image}/>
                    <p className={classes.textInstruction}>Przewijaj ekran do końca, aby nie przeoczyć żadnych treści</p>
                </div>
                <div className={classes.instructionRow}>
                    <img src={'strzałki.svg'} className={classes.image}/>
                    <p className={classes.textInstruction}>strzałkami możesz przełączać się między pytaniami</p>
                </div>
                <div className={classes.instructionRow}>
                    <img src={'przycisk.png'} className={classes.image} style={{width: 60, height: 18}}/>
                    <p className={classes.textInstruction}>przyciskiem „sprawdzam” musisz potwierdzić odpowiedź</p>
                </div>
                <div className={classes.instructionRow}>
                    <img src={'kolko-zaznaczone.svg'} className={classes.image}  style={{width: 60, height: 30}}/>
                    <p className={classes.textInstruction}>odpowiedz na wszystkie pytania, aby zobaczyć wynik końcowy</p>
                </div>
                <div className={classes.instructionRow}>
                    <img src={'noun-heat-wave-3189081 2.svg'} className={classes.image}/>
                    <p className={classes.textInstruction}>na końcu quizu otrzymasz linki do wiarygodnych źródeł informacji</p>
                </div>
                <div style={{flex: '1 1 auto'}}/>
            </div>
            <Navigation buttonPath={'/quiz-klimatyczny/quiz'} buttonText={'zaczynam'} isGreen={true}/>
        </main>
    );
}